import { useEffect, useRef, useState } from 'react';
import './Animation.css';

export default function Animation() {
    const particlesRef = useRef(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const container = particlesRef.current;
        const particlesArray = [];

        for (let i = 0; i < 50; i++) {
            const particle = document.createElement('div');
            particle.className = 'particle';
            particle.style.left = `${Math.random() * 100}%`;
            particle.style.top = `${Math.random() * 100}%`;
            particle.style.animationDelay = `${Math.random() * 6}s`;
            container.appendChild(particle);
            particlesArray.push(particle);
        }

        const timer = setTimeout(() => setLoading(false), 1500);

        return () => {
            clearTimeout(timer);
            particlesArray.forEach(p => container.removeChild(p));
        };
    }, []);

    return (
        <>
            {loading && (
                <div className="loading-screen">
                    <div className="loader"></div>
                </div>
            )}

            <div className="bg-animation"></div>
            <div ref={particlesRef} className="particles"></div>
        </>
    );
};